<template>

<!-- <table class='availability table'>
                        <thead class="thead-light">
                            <tr>
                                <th style='width: 25%'>Day</th>
                                <th style='width: 25%'>Availability</th>
                                <th style='width: 35%'>Session type</th>
                                <th style='width: 15%'></th>
                            </tr>
                        </thead>
                        
                        
                        
                    </table> -->



    <table v-if='value' class='availability table'>
        <thead class="thead-light">
            <tr>
                <th>{{ $t('translations.day')}}</th>
                <th>{{ $t('translations.availability')}}</th>
                <th>{{ $t('translations.session_name')}}</th>
                <th v-if='edit'>
                    &nbsp;
                    <!-- <button v-on:click.prevent='value.push({name: "", id: 0})' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button> -->
                </th>
            </tr>
        </thead>
        <template v-for="(day, day_of_week) in $root.lookup.dayNames">
                                
            <tr :key='day_of_week' class='day_heading'>
                <td :colspan='3'>{{ day | capitalise}}</td>
                <td v-if='edit'>
                    <button v-on:click.prevent='value.push({day_of_week: day_of_week, start_at: null, end_at: null, appointment_session_type_id: null})' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button>
                </td>
            </tr>
            <template v-if='getAvailabilityIndexes(value, day_of_week).length'>
                <template v-for='(date_index) in getAvailabilityIndexes(value, day_of_week)'>
                    <appointment-session 
                        v-model='value[date_index]' 
                        :appointment_session_type='appointment_session_type'
                        :key='"" + day_of_week + "-" + date_index' 
                        :edit='edit'
                        @remove='value.splice(date_index, 1)' />
                </template>
            </template>
            <template v-else>
                <tr :key='"" + day_of_week + "-none"'>
                    <td :colspan='edit ? 4 : 3'>{{ $t('translations.no_sessions_found')}}</td>
                </tr>
            </template>
        </template>
    </table>
</template>

<script>

export default {
    name: 'appointment-session-table',
    props: {
        value: {

        },
        appointment_session_type: {

        },
        edit: {
            default: false
        }
    },
    data() {
        return {
            
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        
    },
};
</script>